import { MenuItem, SelectField } from 'material-ui';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

function Exdd({ exdd, changeExdd }) {

    return (
        <SelectField
            floatingLabelText='Exdd'
            floatingLabelStyle={{ fontSize: '14px' }}
            style={{ fontSize: '13px' }}
            onChange={changeExdd}
            value={exdd}
            autoWidth
        >
            <MenuItem value={undefined} />
            <MenuItem value="exdd" primaryText='ex dry dock' />
            <MenuItem value="exss" primaryText='ex ss' />
            <MenuItem value="exddss" primaryText='ex dd/ss' />
        </SelectField>
    );
}

export default connect(
    null,
    dispatch => bindActionCreators({
    },
    dispatch),
)(Exdd);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Vessel/Sidebar/Order/OpenPosition/Exdd.jsx